import React from "react";
import { Link } from "react-router-dom";
import "./StaticHeroSection.scss";

const loginUrl = process.env.REACT_APP_DASHBOARD_LOGIN;
const HeroVideo = () => {
  return (
    <div className="hero-video">
      {/* YouTube Video Background */}
      <div className="video-container">
{/* <iframe
  width="560"
  height="315"
  src="https://www.youtube.com/embed/OISmvKZU-FY?si=wIRWIyCJJgGvRtGT&autoplay=1&mute=1&controls=0&loop=1&playlist=OISmvKZU-FY"
  title="YouTube video player"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  referrerPolicy="strict-origin-when-cross-origin"
  allowFullScreen
  className="youtube-video"
  loading="lazy"
/> */}
        <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="/video/Hot-Freight.mkv"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />
      </div>

      {/* Dark overlay for better text contrast */}
      <div className="video-overlay"></div>

      {/* Static Content */}
      <div className="hero-content">
        <h1>
          Canada's Leading <span className="highlight">Freight</span> &{" "}
          <span className="highlight">Warehousing</span> Partner
        </h1>
        <p className="subtitle">
          Reliable Solutions for Logistics, Distribution & Tradeshow Delivery
          Across Canada, the USA, and Cross-Border. Freight Options:
          Over-the-Road, Air, Rail, Ocean
        </p>

        <div className="cta-buttons">
          <Link to="/GetAQuote" className="cta-primary cta-link">
            GET A QUOTE
          </Link>
          <a
            href={loginUrl}
            target="_blank"
            className="cta-secondary cta-link"
          >
            log In
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroVideo;
